module.exports = __webpack_public_path__ + "img/compenstate_popup_ btn.051d0937.png";